import React, { FC, ReactNode } from "react";

/**
 * Lifts an imported button that has no size prop to 44px below md, the page's
 * touch floor (btnClass's max-md:h-11): ScoreState's PrimaryButton (36px) and
 * RetryButton (32px). Those stay as they are on the video page; this wrapper
 * outranks them here only, as the page ⋮ wrappers do (MENU_TRIGGER).
 *
 *   <TouchTarget><RetryButton onClick={reload} /></TouchTarget>
 */
export const TouchTarget: FC<{ children: ReactNode }> = ({ children }) => (
  <span className="inline-flex max-md:[&>button]:h-11">{children}</span>
);
